<script lang="ts" setup>
import Theme from './step/theme.vue';
import Generation from './step/generation.vue';
import PPtTemplate from './step/ppt-template.vue';
import PreinstallGeneration from './step/preinstall-generation.vue';
import SlideEdit from './step/slideEdit.vue';

import { step } from './use/data.ts';
import { getPreinstall } from './preinstall/preinstall';

getPreinstall();
</script>
<template>
  <div class="full relative">
    <div full absolute t-0 l-0 style="z-index: -1">
      <CsdImg class="w-full" src="/images/aiDoc/empty-bg.png" />
    </div>
    <Theme v-if="step === 'theme'" />
    <Generation v-if="step === 'generation'" />
    <PreinstallGeneration v-if="step === 'preinstall-generation'" />
    <PPtTemplate v-if="step === 'template'" />
    <SlideEdit v-if="step == 'slide-ppt'" />
  </div>
</template>
